module.exports = __webpack_public_path__ + "img/pitch_play_right.0e186847.jpg";